module.exports = __webpack_public_path__ + "img/default.d8a851d0.jpg";